export const generators = [
  'G-023|Bookcases and shelves|1x3',
  'G-223|Railway Tracks|1x1',
  'G-203|Bowls|1x1',
  'G-255|Light Machine Guns|1x1',
  'G-182|Cartoon Space Rockets|1x1',
  'G-324|Bon Fires|1x1',
  'G-296|Hammers|1x1',
  'G-137|Sheds|1x1',
  'G-227|Modern Houses|1x1',
  'G-233|Cannons|1x1',
  'G-111|Name plaque|1x1',
  'G-409|Trophy|1x1',
  'G-359|Stylized fences|1x1',
  'G-030|Bench Press|1x1',
  'G-259|Military Crates|1x1',
  'G-320|Vacuum Cleaners|1x1',
  'G-052|Missiles and bombs|1x1',
  'G-105|Baseball Bat|1x1',
  'G-393|Stalagmites|1x1',
  'G-135|Spiral staircases|1x1',
  'G-332|Castle Side Towers|1x1',
  'G-362|Jellyfish|1x1',
  'G-149|Benches|2x1',
  'G-154|Bus Stops|1x1',
  'G-344|Stage Lights|1x1',
  'G-041|Bows|1x1',
  'G-370|Coffee Pots|1x1',
  'G-391|Headphones|1x1',
  'G-113|Sails|1x1',
  'G-084|Vents|1x1',
  'G-076|Missile Silos|1x1',
  'G-124|Castle Towers|1x1',
  'G-064|Shower Cabinets|1x1',
  'G-309|Limousines|1x1',
  'G-348|Orange|1x1',
  'G-108|Tent Pegs|1x1',
  'G-171|Walking Bridges|1x1',
  'G-240|Sinks|1x1',
  'G-033|Stairs|1x1',
  'G-317|Hoes|1x1',
  'G-239|Keyboards|1x1',
  'G-058|Hammers|1x1',
  'G-009|Sun bed|1x1',
  'G-169|Mage staff|1x1',
  'G-072|Airplanes|1x1',
  'G-167|Windows|1x1',
  'G-283|Lamps|1x1',
  'G-015|Dining Chairs|1x1',
  'G-132|Pitch Fork|1x1',
  'G-156|Scaffolding|1x1',
  'G-212|Tanks and Armored Vehicle|1x1',
  'G-234|Sofas and recliners|2x1',
  'G-208|Skyscrapers|1x1',
  'G-267|Battering Rams|1x1',
  'G-141|Roof with tiles|1x1',
  'G-371|Ceiling Lamps|1x1',
  'G-032|Tents|1x1',
  'G-248|Tractor Wagons|1x1',
  'G-305|Two Seat Cars|1x1',
  'G-069|Syringes|1x1',
  'G-166|Crossbow|1x1',
  'G-164|Broom|1x1',
  'G-055|Radios|1x1',
  'G-144|Garbage Cans|1x1',
  'G-277|Medieval Defence Walls|1x1',
  'G-186|Telescope|1x1',
  'G-361|Sci-fi small buildings|1x1',
  'G-077|Canes|1x1',
  'G-093|Floor Signs|1x1',
  'G-159|See Saws|1x1',
  'G-201|Beer Glasses|1x1',
  'G-051|Binders|1x1',
  'G-018|Picket Fences|1x1',
  'G-090|Lollipops|1x1',
  'G-112|Chain|1x1',
  'G-014|Office Partitions|1x1',
  'G-265|Wooden Platforms|1x1',
  'G-088|Traffic Cones|1x1',
  'G-057|Space Rockets|1x1',
  'G-273|Signs|1x1',
  'G-222|Silos|1x1',
  'G-279|Storefront Buildings|1x1',
  'G-133|Lanterns|1x1',
  'G-413|Shotguns|1x1',
  'G-190|Nightstand|1x1',
  'G-219|Churches|1x1',
  'G-403|Welding mask|1x1',
  'G-408|Cakes|1x1',
  'G-389|Musket|1x1',
  'G-177|Spaceships|1x1',
  'G-297|Blinds|1x1',
  'G-040|Quivers|1x1',
  'G-175|Flag poles|1x1',
  'G-193|Plates|1x1',
  'G-138|Trellises|1x1',
  'G-292|Pyramids|1x1',
  'G-330|Castle Windows|1x1',
  'G-266|Siege Towers|1x1',
  'G-340|Guitars|1x1',
  'G-242|Tomb Stones|1x1',
  'G-120|Grindstones|1x1',
  'G-020|Ceiling fans|1x1',
  'G-106|Darts|1x1',
  'G-074|Office Chairs|1x1',
  'G-172|Finger Signs|1x1',
  'G-335|Castle Towers|1x1',
  'G-082|Bike Stands|1x1',
  'G-250|Microwaves|1x1',
  'G-394|Sail Boats|1x1',
  'G-005|Sauce Bottles |1x1',
  'G-188|Sci-FiConsoles|1x1',
  'G-178|Roof Modular Pieces|1x1',
  'G-024|Candles|1x1',
  'G-355|Portable Site Buildings|1x1',
  'G-257|Small Robots|1x1',
  'G-387|Pizzas|1x1',
  'G-073|Sci-fi Towers|1x1',
  'G-213|Picture Frames|1x1',
  'G-363|Glasses|1x1',
  'G-192|Torch|1x1',
  'G-152|Sand Boxes|1x1',
  'G-134|Chimneys|1x1',
  'G-398|Cupcakes|1x1',
  'G-098|Phones|1x1',
  'G-356|Refrigerators|2x2',
  'G-059|Front Desks|3x2',
  'G-008|Gongs|1x1',
  'G-185|Fire Hydrants|1x1',
  'G-402|Explosives|1x1',
  'G-081|I-Beams|1x1',
  'G-184|Raft|1x1',
  'G-173|Distilleries|1x1',
  'G-379|School lockers|1x1',
  'G-181|Sci-fi Planes|1x1',
  'G-271|Wardrobes|1x1',
  'G-251|Blenders|1x1',
  'G-218|Aztec Pyramids|1x1',
  'G-191|Watchtower|1x1',
  'G-316|Scythes|1x1',
  'G-021|Bridges|1x1',
  'G-323|Cubes|1x1',
  'G-314|Cages|1x1',
  'G-272|Weight Racks|1x1',
  'G-289|Planets|1x1',
  'G-045|Horizontal Fence|1x1',
  'G-066|Carts and Wagons|1x1',
  'G-142|Ladders|1x1',
  'G-126|Cranks|1x1',
  'G-236|Ranch Gates|1x1',
  'G-053|Go Karts|1x1',
  'G-198|Cocktail Glassess|1x1',
  'G-241|Kitchen Counter|1x1',
  'G-303|Arcade Machines|1x1',
  'G-327|Turntables|1x1',
  'G-121|Brickwalls|1x1',
  'G-080|Rings|1x1',
  'G-338|Skyscrapers|1x1',
  'G-096|Clocks|1x1',
  'G-197|Wine Glasses|1x1',
  'G-270|Ray Guns|1x1',
  'G-285|Wooden Towers|1x1',
  'G-286|Shop Signs|1x1',
  'G-204|Vases|1x1',
  'G-282|Computers|1x1',
  'G-129|Globuses|1x1',
  'G-046|Spear|1x1',
  'G-078|Ingots|1x1',
  'G-131|Chests|1x1',
  'G-321|Atoms|1x1',
  'G-117|Clipboards|1x1',
  'G-019|Contemporary Shelves|1x1',
  'G-351|Apple|1x1',
  'G-215|Crystal Balls|1x1',
  'G-070|Columns|1x1',
  'G-343|DJ Mixers|1x1',
  'G-101|Trees|1x1',
  'G-354|Barbed Wire Fences|1x1',
  'G-107|Torii Gates|1x1',
  'G-276|Crystals and Gems|1x1',
  'G-358|Baby cribs|1x1',
  'G-372|Gas Stations|1x1',
  'G-128|Cabinets|1x1',
  'G-225|Basketball hoop|1x1',
  'G-003|Fireplace|1x1',
  'G-253|Megaphones|1x1',
  'G-022|Simple Benches|1x1',
  'G-221|Water Towers|1x1',
  'G-100|3D Printer|1x1',
  'G-161|Knives|1x1',
  'G-339|Office Buildings|1x1',
  'G-157|Construction Barriers|1x1',
  'G-260|Cans|1x1',
  'G-145|Traffic signs|1x1',
  'G-301|Artillery Mortars|1x1',
  'G-229|Desert Houses|1x1',
  'G-262|Table Lamps|1x1',
  'G-011|Window Muntins|1x1',
  'G-029|Cups and Glasses |1x1',
  'G-147|Road Blocks|1x1',
  'G-244|Mech Robots|1x1',
  'G-256|Grenade Launchers|1x1',
  'G-220|Jungle Temples|1x1',
  'G-061|Swords|1x1',
  'G-368|Aquariums|1x1',
  'G-162|Road Signs|1x1',
  'G-322|Gifts|1x1',
  'G-231|Square Dining Tables|1x1',
  'G-002|TV Benchs|1x1',
  'G-027|Pencils|1x1',
  'G-306|Four Seat Cars|1x1',
  'G-337|Castle Main Palaces|1x1',
  'G-404|University buildings|1x1',
  'G-050|Doors|1x1',
  'G-385|Pots|1x1',
  'G-187|Compass|1x1',
  'G-087|Magnifying Glass|1x1',
  'G-258|Market Stalls|1x1',
  'G-116|Bicycle chains|1x1',
  'G-047|Log Cabins|1x1',
  'G-329|Banners|1x1',
  'G-333|Castle Walls|1x1',
  'G-028|Notebooks|1x1',
  'G-237|Kitchen Drawers|1x1',
  'G-035|Coat Rack|1x1',
  'G-067|Submarines|1x1',
  'G-281|Computer Mouse|1x1',
  'G-342|Synthesizers|1x1',
  'G-386|Jello|1x1',
  'G-304|Coffee Machines|1x1',
  'G-298|Rooms|1x1',
  'G-275|Laptops|1x1',
  'G-263|UFOs|1x1',
  'G-016|Castle Walls|1x1',
  'G-226|Barns|1x1',
  'G-122|Coins|1x1',
  'G-034|Weights |1x1',
  'G-114|Screws and hooks|1x1',
  'G-217|Roman Buildings|1x1',
  'G-405|Terrains|1x1',
  'G-367|Helmets|1x1',
  'G-360|Space stations|1x1',
  'G-396|Conveyor Belts|1x1',
  'G-007|Fireworks Rocket|1x1',
  'G-411|Cast Iron Stoves|1x1',
  'G-026|Turrets|1x1',
  'G-369|Radiators|1x1',
  'G-001|Shoe Stand|1x1',
  'G-097|Robots and Humanoids|1x1',
  'G-049|Underwater Mine|1x1',
  'G-025|Trash Cans|1x1',
  'G-400|Bushes|1x1',
  'G-345|Desks|1x2',
  'G-123|Sci- Fi Container|1x1',
  'G-013|Cubicals|1x1',
  'G-268|Water Mills|1x1',
  'G-388|Handbag|1x1',
  'G-115|Rakes|1x1',
  'G-313|Toilet Paper|1x1',
  'G-326|Gas Pumps|1x1',
  'G-103|Mace|1x1',
  'G-247|Bear Traps|1x1',
  'G-146|Swings|1x1',
  'G-065|Pergolas and open houses|1x1',
  'G-318|Buckets|1x1',
  'G-366|Bread|1x1',
  'G-390|Small Plants|1x1',
  'G-235|Mushrooms|1x1',
  'G-294|Pickaxes|1x1',
  'G-299|Spray Bottles|1x1',
  'G-406|Toon Characters|1x1',
  'G-165|Books|1x1',
  'G-143|Mail Boxes|1x1',
  'G-179|Wall Modular Pieces|1x1',
  'G-319|Shovels|1x1',
  'G-151|Ash Trays|1x1',
  'G-206|Rifles|1x1',
  'G-150|Wells|1x1',
  'G-010|Stools|1x1',
  'G-086|Zeppelins|1x1',
  'G-376|Skateboards|1x1',
  'G-180|Column Modular Pieces|1x1',
  'G-153|Flower Urns|1x1',
  'G-245|Wild West Buildings|1x1',
  'G-375|Modular Skateparks|1x1',
  'G-037|Pipes|1x1',
  'G-048|Morningstar|1x1',
  'G-176|Traffic Lights|1x1',
  'G-274|Foot Rests|1x1',
  'G-094|Padlock|1x1',
  'G-377|Hanging Sign|1x1',
  'G-380|Stationary Turrets|1x1',
  'G-089|Statue Bases|1x1',
  'G-302|Fire Extinguishers|1x1',
  'G-140|Fountains|1x1',
  'G-383|Rocks|1x1',
  'G-357|Minecarts|1x1',
  'G-308|Station Wagons|1x1',
  'G-189|Medieval Weapon Racks|1x1',
  'G-042|Arrows|1x1',
  'G-228|Rocket launchers|1x1',
  'G-139|Dumpsters|1x1',
  'G-062|Screw Nuts|1x1',
  'G-209|Grenades|1x1',
  'G-395|Factories|1x1',
  'G-381|Recliners|1x1',
  'G-174|Lighthouses|1x1',
  'G-036|Bicycle Wheel|1x1',
  'G-207|Apartment Buildings|1x1',
  'G-183|Sci-Fi Tank|1x1',
  'G-365|Melon|1x1',
  'G-246|Medieval Houses|1x1',
  'G-269|Horton Spheres|1x1',
  'G-195|Post Box|1x1',
  'G-160|Pistol|1x1',
  'G-230|Office Desks|3x2',
  'G-054|Laser Sword|1x1',
  'G-315|Gallows|1x1',
  'G-063|Miniguns|1x1',
  'G-202|Spirit Glasses|1x1',
  'G-311|Pickups|1x1',
  'G-104|Tiles|1x1',
  'G-341|Microphones|1x1',
  'G-378|Drop Pods|1x1',
  'G-224|Tractors|1x1',
  'G-071|Ovens|1x1',
  'G-336|Castles and Palaces|1x1',
  'G-199|Stylized Beds|1x1',
  'G-012|School Chairs|1x1',
  'G-194|Surveillance Cameras|1x1',
  'G-006|Round Table|1x1',
  'G-295|Wrenches|1x1',
  'G-200|Bathtub|1x1',
  'G-170|Pallets|1x1',
  'G-252|Storage Buildings|1x1',
  'G-232|Round Dining Table|2x2',
  'G-168|Sci-fi guns|1x1',
  'G-284|Solar Panels|1x1',
  'G-364|Strawberries|1x1',
  'G-060|Street Lights|1x1',
  'G-099|Nails|1x1',
  'G-288|Long Benches|3x1',
  'G-399|Necklace|1x1',
  'G-350|Lemon|1x1',
  'G-331|Castle Bridges|1x1',
  'G-119|Soap and Perfume Dispensers|1x1',
  'G-085|Container shelf|1x1',
  'G-031|Rectangular Tables|1x1',
  'G-205|Residential Houses|1x1',
  'G-004|Speaker|1x1',
  'G-346|Military Camp Tents|1x1',
  'G-280|Hats|1x1',
  'G-068|Portals|1x1',
  'G-163|Chairs|1x1',
  'G-136|Windmills|1x1',
  'G-056|Potions and Bottles|1x1',
  'G-125|Container|1x1',
  'G-216|Boat Docks|1x1',
  'G-312|Buses|1x1',
  'G-384|Frying Pans|1x1',
  'G-214|Locomotive Trains|1x1',
  'G-038|Altars|1x1',
  'G-243|Drones|1x1',
  'G-328|Trucks|1x1',
  'G-211|Cauldron|1x1',
  'G-109|Sink Taps|1x1',
  'G-261|Bottles|1x1',
  'G-291|Balls|1x1',
  'G-127|Estate Signs|1x1',
  'G-043|Screens|1x1',
  'G-307|SUVs|1x1',
  'G-017|Crates|1x1',
  'G-238|Leaning Chair|1x1',
  'G-079|Board Game Pieces|1x1',
  'G-254|Batons|1x1',
  'G-091|Pianos|2x1',
  'G-155|Crane|1x1',
  'G-401|Ancient Ruins|1x1',
  'G-287|Convenience Stores|1x1',
  'G-349|Pear|1x1',
  'G-095|Paperclips|1x1',
  'G-397|Earrings|1x1',
  'G-300|Table Fans|1x1',
  'G-382|Euphyllia Corals|1x1',
  'G-130|Paint Roller|1x1',
  'G-110|Spatulas|1x1',
  'G-044|Bikes|1x1',
  'G-039|Suitcases|1x1',
  'G-118|Wine Rack|1x1',
  'G-158|Billboards|1x1',
  'G-102|Flower Box|1x1',
  'G-374|Folding Chairs|1x1',
  'G-310|Vans|1x1',
  'G-075|Shields|1x1',
  'G-347|Pennant|1x1',
  'G-352|Road sections|1x1',
  'G-083|Barrels|1x1',
  'G-410|Bunkers|1x1',
  'G-278|Sci-fi Buildings|1x1',
  'G-092|Satellites|1x1',
  'G-196|Catapult|1x1',
  'G-249|Wooden Wheels|1x1',
  'G-325|Hand Saws|1x1',
  'G-334|Castle Gates|1x1',
  'G-148|Slides|1x1',
  'G-293|Cardboard Boxes|1x1',
  'G-373|Operating Tables|1x1',
  'G-353|Axes|1x1',
  'G-392|Backpacks|1x1',
  'G-210|Bells|1x1',
];
